import { styled } from '@mui/system';
import { Table } from '@mui/material';

export const StyledTable = styled(Table)(() => ({
  width: '100%'
}));

export const Cnt = styled('div')(({ theme }) => ({
  marginTop: theme.spacing()
}));
